var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88945 4.3291H18.9288C19.9628 4.3291 20.8087 5.15362 20.8087 6.16137V17.155C20.8087 18.1627 19.9628 18.9872 18.9288 18.9872H3.88945C2.85549 18.9872 2.00953 18.1627 2.00953 17.155V6.16137C2.00953 5.15362 2.85549 4.3291 3.88945 4.3291Z",
    stroke: "white",
    strokeWidth: 1.87992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8087 6.16138L11.4091 12.5743L2.00953 6.16138",
    stroke: "white",
    strokeWidth: 1.87992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1533053b12b307b7fc832b9101b9d549.svg";
export { ForwardRef as ReactComponent };